import { Tag } from "@/components/molecules/Tag";
import clsx from "clsx";
import Image from "next/image";

export const ProjectCover = ({
  id,
  bgClassName,
  imageClassName,
  title,
  src,
  intro,
  tag,
}) => {
  return (
    <>
      <div className="px-0 md:px-4 lg:px-0">
        <div
          className={clsx(
            bgClassName,
            "relative box-border flex aspect-1.4/1 items-end justify-start px-4 pt-16 pb-4 text-txt-base sm:aspect-2/1 md:px-8 md:py-6 lg:px-12 lg:py-10"
          )}
        >
          <div>
            <h6 className=" mb-4 text-sm font-bold md:mb-10 md:text-md ">
              Project No.{id}
            </h6>
            <h2 className=" mb-4 font-bold leading-relaxed fluid-text-[18px,39px] ">
              <div dangerouslySetInnerHTML={{ __html: `${title}` }} />
            </h2>
            <div className="flex flex-wrap gap-2">
              {tag.map((tag) => (
                <Tag key={id}>{tag}</Tag>
              ))}
            </div>
          </div>
          <h4 className={clsx(imageClassName, "absolute block")}>
            <Image
              src={src}
              alt={title}
              quality={80}
              layout="fill"
              objectFit="contain"
            />
          </h4>
        </div>
        <div className="border border-x-0 border-t-0 border-solid border-bdc-light p-4 leading-comfort text-txt-base fluid-text-[14px,18px] md:border-x md:border-bdc-base md:px-8 md:py-6 lg:px-14 lg:py-8 ">
          <div dangerouslySetInnerHTML={{ __html: `${intro}` }} />
        </div>
      </div>
    </>
  );
};
